import { useEffect, useRef, useState } from "react";
import { Box, Slide, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DeviceStatus from "./DeviceStatus";

interface IConnectionSpinnerProps {
  deviceName: string;
  isConnectionError: boolean;
  connectionErrorMessage: string;
}

const ConnectionSpinner = ({ deviceName, isConnectionError, connectionErrorMessage }: IConnectionSpinnerProps) => {
  const theme = useTheme();
  const [slideIn, setSlideIn] = useState(true);
  const [deviceStatusWidth, setDeviceStatusWidth] = useState(0);
  const deviceStatusRef = useRef<HTMLDivElement>(null);
  const handleMouseEnter = () => {
    if (!isConnectionError) {
      let timer;
      if (!timer) {
        setSlideIn(false);
      }
      timer = setTimeout(() => {
        setSlideIn(true);
      }, 4000)
    }
  };

  useEffect(() => {
    if (deviceStatusRef.current) {
      setDeviceStatusWidth(deviceStatusRef.current.offsetWidth);
    }
  }, [deviceName]);

  return (
    <Box
      className="no-select"
      pb={2}
      pl={2}
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        zIndex: 10,
        pointerEvents: slideIn ? 'auto' : 'none',
        overflow: "hidden",
      }}
    >
      <Slide direction="down" in={slideIn}>
        <Paper
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.palette.background.paper,
            borderBottomLeftRadius: 25,
            borderTopRightRadius: 0,
            justifyContent: 'center',
            padding: theme.spacing(2),
            gap: 2,
            boxShadow: theme.shadows[1],
          }}
          onMouseEnter={handleMouseEnter}
        >
          <div ref={deviceStatusRef}>
            <DeviceStatus deviceName={deviceName} isConnectionError={isConnectionError} />
          </div>
        </Paper>
      </Slide>
    </Box>
  );
};

export default ConnectionSpinner;
